export function getAbsolutePath(path: string) {
  return `/app/${path}`;
}
